import { c as _c } from "react/compiler-runtime";
import { useState } from "react";

/**
 * Pair of visibility + mount state for CSS transitions (render while animating out).
 * Returns: [show, render, onTransitionEnd, toggle, close, open]
 */
export default function useToggleAnimationState(onChange) {
  const $ = _c(17);
  const [renderElement, setRenderElement] = useState(false);
  const [showElement, setShowElement] = useState(false);
  let t0;
  if ($[0] !== onChange) {
    t0 = () => {
      setShowElement(false);
      onChange?.(false);
    };
    $[0] = onChange;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const close = t0;
  let t1;
  if ($[2] !== onChange) {
    t1 = () => {
      setRenderElement(true);
      setTimeout(() => {
        setShowElement(true);
      }, 0);
      onChange?.(true);
    };
    $[2] = onChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const open = t1;
  let t2;
  if ($[4] !== close || $[5] !== open || $[6] !== showElement) {
    t2 = () => {
      if (showElement) {
        close();
      } else {
        open();
      }
    };
    $[4] = close;
    $[5] = open;
    $[6] = showElement;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const toggle = t2;
  let t3;
  if ($[8] !== showElement) {
    t3 = function handleTransitionEnd() {
      setRenderElement(showElement);
    };
    $[8] = showElement;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleTransitionEnd = t3;
  let t4;
  if ($[10] !== close || $[11] !== handleTransitionEnd || $[12] !== open || $[13] !== renderElement || $[14] !== showElement || $[15] !== toggle) {
    t4 = [showElement, renderElement, handleTransitionEnd, toggle, close, open];
    $[10] = close;
    $[11] = handleTransitionEnd;
    $[12] = open;
    $[13] = renderElement;
    $[14] = showElement;
    $[15] = toggle;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}